import { FaApple, FaAndroid, FaLaptop } from "react-icons/fa";
import axios from "axios";

const InfoLink = ({ item, set_data_edit }) => {
    const handleChange = (item) => {
        console.log(item);
        set_data_edit(item);
    };
    const mision_copy = (id) => {
        // Hỏi người dùng có muốn sao chép không
        if (window.confirm("Bạn có muốn sao chép mission không?")) {
            axios
                .post('https://hust.media/jop/mission/admin/mision_copy.php', {
                    // Truyền tham số qua thuộc tính params
                    id_mission: id 
                })
                .then((response) => {
                    testFunction(response);
                    alert('Request successful!');
                })
                .catch((error) => {
                    console.error('Error:', error);
                    alert('Request failed!');
                });
        }
    };

    // Hàm testFunction xử lý response từ server
    const testFunction = (response) => {
        console.log('Response data:', response.data);
        // Xử lý dữ liệu trả về nếu cần
    };

    return (
        <>
            {/* Row chứa link và nút edit */}
            <div className="flex items-center gap-2">
                <a
                    target="_blank"
                    rel="noreferrer"
                    href={item.api_category}
                    className="text-gray-700"
                >
                    {item.api_category}
                </a>
            </div>
            <div className="flex items-center gap-2">
                <div
                    onClick={() => handleChange(item)}
                    className="cursor-pointer text-blue-500"
                >
                    Edit
                </div>
                <div
                    onClick={() => mision_copy(item.id)}
                    className="cursor-pointer text-blue-500"
                >
                    copy
                </div>
            </div>

            {item.description.includes("<div>") ? (
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
            ) : (
                <p className="mb-1 text-gray-700">{item.description}</p>
            )}

            <div className="border-t border-gray-300 my-1"></div>

            <div className="grid grid-cols-4 gap-4 items-center">
                <div className="mb-0 inline-block">
                    <div className="text-sm inline-block"> 🌾</div>
                    <div className="text-lg font-semibold text-blue-600 block">
                        {item.price} Coins
                    </div>
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    🌲 Delay {item.time} s
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    {item.minorder === "0" ? (
                        <>
                            {item.views}/{parseFloat((1 / item.maxorder).toFixed(2))}
                        </>
                    ) : (
                        <>👁 {item.views}/{item.maxorder} Views</>
                    )}
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    <div className="flex text-base">
                        {item.type_api.includes("only_app") ? (
                            <>
                                <FaApple />
                                <FaAndroid />
                            </>
                        ) : (
                            <>
                                <FaLaptop />
                                <FaApple />
                                <FaAndroid />
                            </>
                        )}
                    </div>
                    device
                </div>
            </div>
        </>
    );
};

export default InfoLink;
